import { render, staticRenderFns } from "./TheTransactionsTableWrapper.vue?vue&type=template&id=2f8fe99f&scoped=true"
import script from "./TheTransactionsTableWrapper.vue?vue&type=script&lang=js"
export * from "./TheTransactionsTableWrapper.vue?vue&type=script&lang=js"
import style0 from "./TheTransactionsTableWrapper.vue?vue&type=style&index=0&id=2f8fe99f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8fe99f",
  null
  
)

export default component.exports